export { default } from './VendorRequestStatusLabel';
